import React from 'react';
import { Control, FieldErrors, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { EmergencyContactFieldset, SpecialNeedsFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';

interface HealthStepProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const HealthStep: React.FC<HealthStepProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="p-4 sm:p-6">
            <div className="space-y-8">
                <EmergencyContactFieldset
                    context={context}
                    collaboratorId={collaboratorId}
                    control={control}
                    watch={watch}
                    errors={errors}
                    isSubmitting={isSubmitting}
                    layout="compact"
                    isProfileUpdate={true}
                />

                <SpecialNeedsFieldset
                    context={context}
                    collaboratorId={collaboratorId}
                    control={control}
                    setValue={setValue}
                    watch={watch}
                    errors={errors}
                    isSubmitting={isSubmitting}
                />
            </div>
        </div>
    );
};

export default HealthStep;
